<template>
    <!-- xs: full-width rows (currency, then VAT). sm+: two columns side by side within the parent cell. -->
    <v-row>
        <v-col cols="12" sm="5">
            <v-select
                ref="currencyFieldRef"
                :model-value="modelValue.currency"
                :items="currencyItems"
                :label="$t('formFields.currency')"
                :rules="requireCurrency ? currencyRules : []"
                variant="outlined"
                hide-details="auto"
                @update:model-value="onCurrencyUpdate"
            />
        </v-col>
        <v-col cols="12" sm="5">
            <v-checkbox
                :model-value="modelValue.vatType"
                :label="vatCheckboxLabel"
                hide-details="auto"
                @update:model-value="onVatUpdate"
            />
        </v-col>
    </v-row>
</template>

<script>
/** Shared EUR/RON + VAT toggle for listings (FormInfo) and reservation offers. */
export default {
    name: "PriceTermsFields",
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        requireCurrency: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            currencyItems: ["EUR", "RON"],
        };
    },
    computed: {
        vatCheckboxLabel() {
            return this.modelValue?.vatType === true
                ? this.$t("formFields.withVAT")
                : this.$t("formFields.withoutVAT");
        },
        currencyRules() {
            return [
                (value) =>
                    !!String(value || "").trim() || this.$t("validation.required"),
            ];
        },
    },
    methods: {
        onCurrencyUpdate(nextCurrency) {
            this.$emit("update:modelValue", {
                ...this.modelValue,
                currency: nextCurrency,
            });
        },
        onVatUpdate(nextVat) {
            this.$emit("update:modelValue", {
                ...this.modelValue,
                vatType: nextVat,
            });
        },
        async validateFields() {
            if (!this.requireCurrency || !this.$refs.currencyFieldRef) {
                return true;
            }
            await this.$refs.currencyFieldRef.validate();
            return (
                !this.$refs.currencyFieldRef.errorMessages ||
                this.$refs.currencyFieldRef.errorMessages.length === 0
            );
        },
        resetValidation() {
            this.$refs.currencyFieldRef?.resetValidation?.();
        },
    },
};
</script>
